import * as React from "react"
import ElemCheckboxMafo from "../../elements/CheckboxMafo"

interface MafoQuestionProps {
	register: Function
	errors: any
}
const MafoQuestionNine: React.FC<MafoQuestionProps> = ({ register, errors }) => {
	return (
		<>
			<h3 className="mafo-headline text-left text-blue">9. Würdest Du TREK Protein Oat Bars weiterempfehlen?</h3>
			<div className="mx-auto text-left lg:max-w-[100%] pt-1">
				<ElemCheckboxMafo label={<>Sehr wahrscheinlich</>} className=" question9 pb-2 text-green">
					<input type="radio" {...register("question9")} name="question9" value="a" className={"peer absolute hidden h-1 w-1 " + (errors.question9 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Wahrscheinlich</>} className=" question9 pb-2 text-green">
					<input type="radio" {...register("question9")} name="question9" value="b" className={"peer absolute hidden h-1 w-1 " + (errors.question9 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Eher unwahrscheinlich</>} className=" question9 pb-2 text-green">
					<input type="radio" {...register("question9")} name="question9" value="c" className={"peer absolute hidden h-1 w-1 " + (errors.question9 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Unwahrscheinlich</>} className=" question9 pb-2 text-green">
					<input type="radio" {...register("question9")} name="question9" value="d" className={"peer absolute hidden h-1 w-1 " + (errors.question9 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
			</div>
		</>
	)
}

export default MafoQuestionNine
